import React, { useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { useLoader } from "@react-three/fiber";
import * as THREE from "three";
import { OrbitControls } from "@react-three/drei";

const Skybox = ({ imageUrl }) => {
  const skyboxRef = useRef();

  // Load the texture
  const texture = useLoader(THREE.TextureLoader, imageUrl);

  // Rotate the skybox
  useFrame(() => {
    if (skyboxRef.current) {
      skyboxRef.current.rotation.y += 0.001;
    }
  });

  return (
    <>
      <OrbitControls />
      <mesh ref={skyboxRef}>
        <sphereGeometry args={[10, 200, 200]} />
        <meshBasicMaterial map={texture} side={THREE.BackSide} />
      </mesh>
    </>
  );
};

const SkyboxCanvas = ({ imageUrl }) => {
  return (
    <Canvas
      style={{
        width: "100vw",
        height: "100vh",
      }}
      camera={{
        position:[0,0,0.1]
      }}
    >
      <Skybox imageUrl={"/three.jpg"} />
    </Canvas>
  );
};

export default SkyboxCanvas;
